import { colors } from "@indeed/ifl-tokens";
import React from "react";

import { Flex, Text } from "../../../../../../../../mads";

export const ViewJobList: React.FC<{ items: Array<{ key: string; label: string }> }> = ({
  items,
}) => {
  if (!items?.length) {
    return null;
  }

  return (
    <>
      <Flex
        sx={{
          flexDirection: "column",
          position: "relative",
          alignItems: "flex-start",
        }}
      >
        {items.map((item) => (
          <Flex key={item.key} sx={{ flexDirection: "row" }}>
            <Text
              level={3}
              key={item.key}
              sx={{
                color: colors.neutral["800"],
              }}
            >
              {item.label}
            </Text>
          </Flex>
        ))}
      </Flex>
    </>
  );
};
